import { render, staticRenderFns } from "./price-setting.vue?vue&type=template&id=fe8fe8e6&scoped=true&"
import script from "./price-setting.vue?vue&type=script&lang=js&"
export * from "./price-setting.vue?vue&type=script&lang=js&"
import style0 from "./price-setting.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"
import style1 from "./price-setting.vue?vue&type=style&index=1&id=fe8fe8e6&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe8fe8e6",
  null
  
)

export default component.exports